import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthenticationState, AuthInfo } from '../../../authentication/authentication-state';
import { Settings } from '../../../core';
import { SponsorRouteData } from '../../sponsor-route-data';
import { SponsorStudy } from '../../../sponsor-dashboard/sponsor-study';

@Component({
    selector: 'sponsor-ereq-reports',
    template: require('./sponsor-ereq-reports.component.html'),
    styles: [require('./sponsor-ereq-reports.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorEReqReportComponent implements OnInit {

    public bearerToken: string;
    public userEnv: string;
    public selectedStudy: SponsorStudy;
    public preDefinedProtocolFilter = '[{"filterRefId":"ProtocolId","value":""}]';
    public protocolId = 0;

    constructor(private authenticationState: AuthenticationState,
                private readonly routeData: SponsorRouteData,
                private settings: Settings) {

        this.userEnv = this.settings.eReqEnvironment;
    }

    public ngOnInit() {
        this.selectedStudy = this.routeData.snapshot.selectedStudy;
        this.protocolId = this.routeData.snapshot.selectedStudy.ctProtocolId;
        this.preDefinedProtocolFilter = '[{"filterRefId":"ProtocolId","value":"' + this.protocolId + '"}]';
        this.authenticationState.authInfo.subscribe((authState: AuthInfo) => {
            this.bearerToken = authState.idToken.idToken;
        });
    }
}
